module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v(_vm._s(_vm.count))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8f60667e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TlTest.vue
// module id = 2058
// module chunks = 1